document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('.reveal').forEach(el=>{
    const io=new IntersectionObserver(([entry])=>{
      if(entry.isIntersecting){entry.target.classList.add('is-visible');io.disconnect();}
    },{threshold:.15});
    io.observe(el);
  });
});

document.addEventListener('click',(e)=>{
  const thumb=e.target.closest('[data-gallery-thumb]');
  if(!thumb)return;
  const main=document.querySelector('[data-gallery-main]');
  if(main)main.src=thumb.src;
  thumb.parentElement.querySelectorAll('[data-gallery-thumb]').forEach(t=>t.classList.remove('is-active'));
  thumb.classList.add('is-active');
});

document.addEventListener('click',(e)=>{
  const prev=e.target.closest('[data-review-slider-prev]');
  const next=e.target.closest('[data-review-slider-next]');
  if(!prev&&!next)return;
  const track=(prev||next).closest('section').querySelector('[data-review-slider-track]');
  if(!track)return;
  const slide=track.querySelector('.review-slider__slide');
  const step=slide?slide.getBoundingClientRect().width+20:420;
  track.scrollBy({left:prev?-step:step,behavior:'smooth'});
});

document.addEventListener('click',(e)=>{
  const prev=e.target.closest('[data-cards-prev]');
  const next=e.target.closest('[data-cards-next]');
  if(!prev&&!next)return;
  const track=(prev||next).closest('.product-cards-carousel').querySelector('[data-cards-track]');
  if(!track)return;
  const tile=track.querySelector('.product-card-tile');
  const step=tile?tile.getBoundingClientRect().width+14:260;
  track.scrollBy({left:prev?-step:step,behavior:'smooth'});
});

document.addEventListener('click',(e)=>{
  const buyNow=e.target.closest('[data-buy-now]');
  if(!buyNow)return;
  const form=buyNow.closest('form');
  const returnTo=form&&form.querySelector('[data-return-to]');
  if(returnTo)returnTo.value='/checkout';
});

function setActiveReview(wrap,thumb){
  if(!wrap||!thumb)return;
  const photo=wrap.querySelector('[data-review-photo]');
  const label=wrap.querySelector('[data-review-label]');
  const headline=wrap.querySelector('[data-review-headline]');
  const quote=wrap.querySelector('[data-review-quote]');
  const name=wrap.querySelector('[data-review-name]');
  if(photo)photo.src=thumb.dataset.photo;
  if(label)label.textContent=thumb.dataset.label;
  if(headline)headline.innerHTML=thumb.dataset.headline;
  if(quote)quote.textContent=thumb.dataset.quote;
  if(name)name.textContent=thumb.dataset.name;
  wrap.querySelectorAll('[data-review-thumb]').forEach(t=>t.classList.remove('is-active'));
  thumb.classList.add('is-active');
}

document.addEventListener('click',(e)=>{
  const thumb=e.target.closest('[data-review-thumb]');
  if(!thumb)return;
  const wrap=thumb.closest('.buy-reviews');
  setActiveReview(wrap,thumb);
});

document.addEventListener('click',(e)=>{
  const nav=e.target.closest('[data-review-prev],[data-review-next]');
  if(!nav)return;
  const wrap=nav.closest('.buy-reviews');
  if(!wrap)return;
  const thumbs=[...wrap.querySelectorAll('[data-review-thumb]')];
  const current=thumbs.findIndex(t=>t.classList.contains('is-active'));
  const dir=nav.hasAttribute('data-review-next')?1:-1;
  const next=thumbs[(current+dir+thumbs.length)%thumbs.length];
  setActiveReview(wrap,next);
});

function baReviewActivate(thumb){
  if(!thumb)return;
  const wrap=thumb.closest('.ba-review');
  if(!wrap)return;
  wrap.querySelectorAll('[data-ba-thumb]').forEach(t=>t.classList.remove('is-active'));
  thumb.classList.add('is-active');
  const img=wrap.querySelector('[data-ba-image]');
  if(img)img.src=thumb.dataset.img;
  const stat=wrap.querySelector('[data-ba-stat]');
  if(stat)stat.textContent=thumb.dataset.stat;
  const headline=wrap.querySelector('[data-ba-headline]');
  if(headline)headline.textContent=thumb.dataset.headline;
  const pill1=wrap.querySelector('[data-ba-pill1]');
  if(pill1)pill1.textContent=thumb.dataset.pill1;
  const pill2=wrap.querySelector('[data-ba-pill2]');
  if(pill2)pill2.textContent=thumb.dataset.pill2;
}
document.addEventListener('click',(e)=>{
  const thumb=e.target.closest('[data-ba-thumb]');
  if(thumb){baReviewActivate(thumb);return;}
  const navBtn=e.target.closest('[data-ba-prev],[data-ba-next]');
  if(navBtn){
    const wrap=navBtn.closest('.ba-review');
    const thumbs=Array.from(wrap.querySelectorAll('[data-ba-thumb]'));
    const activeIndex=thumbs.findIndex(t=>t.classList.contains('is-active'));
    const dir=navBtn.hasAttribute('data-ba-next')?1:-1;
    const nextIndex=(activeIndex+dir+thumbs.length)%thumbs.length;
    baReviewActivate(thumbs[nextIndex]);
  }
});

document.addEventListener('click',(e)=>{
  const btn=e.target.closest('[data-quick-add]');
  if(!btn)return;
  e.preventDefault();
  e.stopPropagation();
  const variantId=btn.dataset.variantId;
  if(!variantId){window.location.href='/products/beauty-glow-formula-showerhead';return;}
  const originalText=btn.textContent;
  btn.disabled=true;
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:variantId,quantity:1})
  }).then(r=>r.json()).then(()=>{
    const drawer=document.querySelector('cart-drawer');
    if(drawer){drawer.refresh().then(()=>drawer.open());}
  }).catch(()=>{}).finally(()=>{btn.disabled=false;});
});

document.addEventListener('click',(e)=>{
  const arrow=e.target.closest('[data-gallery-prev],[data-gallery-next]');
  if(arrow){
    const thumbs=[...document.querySelectorAll('[data-gallery-thumb]')];
    if(!thumbs.length)return;
    let i=thumbs.findIndex(t=>t.classList.contains('is-active'));
    i=(i+(arrow.hasAttribute('data-gallery-next')?1:-1)+thumbs.length)%thumbs.length;
    thumbs[i].click();
    const row=thumbs[i].parentElement;
    row.scrollTo({left:thumbs[i].offsetLeft-row.clientWidth/2+thumbs[i].clientWidth/2,behavior:'smooth'});
    return;
  }
  const box=document.querySelector('.gallery-highlight');
  if(!box)return;
  if(e.target.closest('[data-gallery-glow]')){box.classList.toggle('is-open');document.querySelector('[data-gallery-glow]').classList.toggle('is-active');return;}
  if(box.classList.contains('is-open')&&!e.target.closest('.gallery-highlight'))box.classList.remove('is-open');
});

document.addEventListener('click',(e)=>{
  const t=e.target.closest('[data-filter-toggle]');
  if(!t)return;
  t.closest('.lab-filter-row').classList.toggle('is-open');
});

document.addEventListener('click',(e)=>{
  if(e.target.closest('[data-info-trigger]')){
    const overlay=document.querySelector('[data-info-overlay]');
    if(overlay)overlay.classList.add('is-open');
    return;
  }
  if(e.target.closest('[data-info-close]')||e.target.matches('[data-info-overlay]')){
    const overlay=document.querySelector('[data-info-overlay]');
    if(overlay)overlay.classList.remove('is-open');
  }
});
document.addEventListener('keydown',(e)=>{
  if(e.key==='Escape'){
    const overlay=document.querySelector('[data-info-overlay].is-open');
    if(overlay)overlay.classList.remove('is-open');
  }
});
